export enum OrganizationType {
    PROVIDER = 'provider', PARTNER = 'partner', INTERNAL = 'internal'
}
